import React from 'react';

export type TierType = 'free' | 'bronze' | 'silver' | 'gold' | 'diamond';

interface TierBadgeProps {
  tier: TierType;
  className?: string;
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier, className = '' }) => {
  const tierConfig: Record<TierType, { label: string; icon: string; badgeClass: string }> = {
    free: {
      label: 'Free',
      icon: '👣',
      badgeClass: 'badge-tier-free',
    },
    bronze: {
      label: 'Bronze',
      icon: '🥉',
      badgeClass: 'badge-tier-bronze',
    },
    silver: {
      label: 'Silver',
      icon: '🥈',
      badgeClass: 'badge-tier-silver',
    },
    gold: {
      label: 'Gold',
      icon: '🥇',
      badgeClass: 'badge-tier-gold',
    },
    diamond: {
      label: 'Diamond',
      icon: '💎',
      badgeClass: 'badge-tier-diamond',
    },
  };

  const config = tierConfig[tier] || tierConfig.free;

  return (
    <span className={`badge ${config.badgeClass} ${className}`}>
      <span>{config.icon}</span>
      <span>{config.label}</span>
    </span>
  );
};
